import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import InfoTooltip from "../../common/InfoTooltip";

interface PanelFieldProps {
    label: string
    hint?: string
    children: React.ReactNode
}

export function PanelField({label, hint, children}: PanelFieldProps) {
    return (
        <Stack gap={0.75}>
            <Stack direction={'row'} alignItems={'center'}>
                <Typography variant={'body2'} fontWeight={500}>
                    {label}
                </Typography>
                {hint && <InfoTooltip title={hint}/>}
            </Stack>
            {children}
        </Stack>
    );
}

interface PanelSectionProps {
    title: string
    children: React.ReactNode
}

export function PanelSection({title, children}: PanelSectionProps) {
    return (
        <Stack gap={2}>
            <Typography variant={'subtitle2'} fontWeight={700} sx={{fontSize: 15}}>
                {title}
            </Typography>
            <Stack gap={2}>
                {children}
            </Stack>
        </Stack>
    );
}
